import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { RouteConstants } from '../constants/route.constant';
import { ContactsAvailabilityService } from '../services/contacts-availability.service';

/**
 * UX gate for the calendar and the client Contact tab while Contacts is switched off for
 * the organisation -- covers the deep links the hidden buttons can't. The API enforces the
 * setting; this only bounces. Waits on the real answer, since the signal starts false.
 */
export const contactsAccessGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);

  return inject(ContactsAvailabilityService).isEnabled$.pipe(
    take(1),
    map((isEnabled) => {
      if (isEnabled) return true;

      const clientUid = route.pathFromRoot.map((r) => r.params['uid']).find(Boolean);

      return clientUid
        ? router.createUrlTree([`/${RouteConstants.CLIENTS_ROUTE}`, clientUid, RouteConstants.CLIENTS_DASHBOARD_ROUTE])
        : router.createUrlTree([`/${RouteConstants.DASHBOARD_ROUTE}`]);
    }),
  );
};
